import useTranslation from "next-translate/useTranslation";
import Popup from "@/components/Popup";
import { subscribe, useWebPush } from "@/ducks/webPush";

export default function WebPushPopup({ show }) {
  const { t } = useTranslation("common");

  const { canSubscribe } = useWebPush();

  if (!canSubscribe) {
    return null;
  }

  return (
    <Popup title={t("Get notified")} onClose={() => show(false)}>
      <div>{t("Get notified desc")}</div>

      <div className="flex items-center justify-end w-full pt-4 mt-4">
        <button
          className="btn btn-base btn-outline"
          onClick={() => show(false)}
        >
          {t("Cancel")}
        </button>
        <button
          className="ml-3 btn btn-base btn-blue"
          onClick={() => {
            if (process.env.NODE_ENV === "production") {
              subscribe();
            }
            show(false);
          }}
        >
          {t("Accept")}
        </button>
      </div>
    </Popup>
  );
}
